function check_queue_ajax_call(obj, callback)
{	
	obj.url = obj.check_queue_url;
	ajaxCall(obj)
	.then(
		function(data) {
			//console.log(data)
			callback(data);
		}, function(error) {
			var http_code = [400, 401, 403];
			console.log(error);
			if(http_code.indexOf(error.status) != -1){
				//default message
				//alert(error.statusText);
				//custom message
				alert(error.responseText);
				window.location.href = obj.loginPage;
			}

		}
	);
}

function login_ajax_call(obj, callback)
{
	obj.url = obj.login_url;
	ajaxCall(obj)
	.then(
		function(data) {
			callback(data);
		}, function(error) {
			preloader.out(function(done){ setTimeout(done, 1000); });
			var http_code = [400, 401, 403];
			console.log(error);
			if(http_code.indexOf(error.status) != -1){
				//default message
				//alert(error.statusText);
				//custom message
				alert(error.responseText);
				window.location.href = obj.loginPage;
			}

		}
	);
}